import {
    createStoreFilter,
    StoreNameExtractor,
} from 'src/modules/store/extractors';
import { IStore } from 'src/interfaces/store';

const extractor = new StoreNameExtractor();

/**
 * Get all make names from stores
 * @param stores - The stores to get the make names from
 * @returns An array of make names
 */

export const getAllMakeNamesFromStores = (stores: IStore[]): string[] =>
    createStoreFilter(extractor)(stores);
